import { useEffect, useState } from 'react';
import { PrimaryButton, SecondaryButton } from '@monorepo/base/src/components/buttons/buttons';
import { Dropdown, option } from '@monorepo/base/src/components/dropdown/dropdown';
import { Input } from '@monorepo/base/src/components/form/input/input';
import { Icon } from '@monorepo/base/src/components/icon/icon';
import styles from './filter-number-menu.module.scss';
import { numberAction, NumberActions } from '@monorepo/tools/src/lib/utils/number';
import { IDebugProps } from '@monorepo/tools/src/lib/interfaces/debug';
import { DataAttribute, generateDataAttrs } from '@monorepo/tools/src/lib/models/data-attr.model';

interface IFilterNumberMenu {
	title: string;
	onApply: (action: numberAction, value: number) => void;
	onCancel: () => void;
	defaultAction?: string;
	defaultValue?: number;
	inputClassNames?: string;
	debugProps?: IDebugProps;
}

export const FilterNumberMenu = (props: IFilterNumberMenu) => {
	const { title, onApply, onCancel, defaultAction = NumberActions.Equals, defaultValue, inputClassNames, debugProps } = props;
	const [action, setAction] = useState<option>(defaultAction);
	const [filterValue, setFilterValue] = useState<number | undefined>(defaultValue);
	const [actionError, setActionError] = useState<string | undefined>(undefined);
	const [inputError, setInputError] = useState<string | undefined>(undefined);
	const { dataAttrs } = debugProps || {};

	// useEffect(() => {
	// 	textInput.current?.focus();
	// }, []);

	useEffect(() => {
		setAction(defaultAction);
	}, [defaultAction]);

	return (
		<div className={styles.wrapper} {...generateDataAttrs(dataAttrs)}>
			<div className={styles.title}>
				{title}
				<Icon isMFP={true} className={styles.closeButton} onClick={onCancel}>
					x-close
				</Icon>
			</div>
			<div className={styles.actionsDiv}>Actions</div>
			<div className={styles.content}>
				<Dropdown
					className={styles.dropdown}
					label={'Actions'}
					required={true}
					defaultOption={action}
					options={[
						NumberActions.Equals,
						NumberActions.GreaterThan,
						NumberActions.GreaterThanEquals,
						NumberActions.LessThan,
						NumberActions.LessThanEquals,
					]}
					debugProps={{ dataAttrs: [new DataAttribute('id', 'filter_action')] }}
					onSelect={(_action: Set<option> | undefined) => {
						setAction(_action?.values().next().value);
						setActionError(undefined);
					}}
					error={actionError}
				/>
				<div className={styles.subTitle}>{title}</div>
				<Input
					className={inputClassNames}
					type={'number'}
					value={filterValue?.toString()}
					onValue={value => {
						setFilterValue(parseInt(value));
						setInputError(undefined);
					}}
					isAutoFocus={true}
					required={true}
					error={inputError}
					debugProps={{ dataAttrs: [new DataAttribute('id', 'action_filter_value')] }}
				/>
			</div>
			<div className={styles.actions}>
				<div className={styles.action}>
					<SecondaryButton
						className={`${styles.actionButton} ${styles.cancelButton}`}
						onClick={onCancel}
						debugProps={{ dataAttrs: [new DataAttribute('id', 'filter_menu_cancel_button')] }}>
						Cancel
					</SecondaryButton>
				</div>
				<div className={styles.action}>
					<PrimaryButton
						className={styles.actionButton}
						onClick={() => {
							if (!filterValue && filterValue !== 0) {
								setInputError('Required');
							}
							if (!action) {
								setActionError('Required');
							}
							if ((filterValue || filterValue === 0) && action) {
								onApply(action as numberAction, filterValue);
							}
						}}
						debugProps={{ dataAttrs: [new DataAttribute('id', 'filter_menu_apply_button')] }}>
						Apply
					</PrimaryButton>
				</div>
			</div>
		</div>
	);
};
